import { useQuery } from '@tanstack/react-query';
import { api } from '../api';
import { formatPln } from '../catalog/money';
import { CONTRACTS_KEY, fileUrl, KINDS, plDay, STATES, type Contract } from './types';
import './contracts.css';

/** "Moje umowy" in "Mój kalendarz" (F44, D16): the user's own contracts with the amount and the PDF — it is their money. */
export function MyContracts() {
  const list = useQuery({ queryKey: [...CONTRACTS_KEY, 'me'], queryFn: () => api<{ contracts: Contract[] }>('/api/contracts/me') });
  const rows = list.data?.contracts ?? [];
  if (rows.length === 0) return null;
  return (
    <section className="fin-section" aria-label="Moje umowy" data-feature-id="contracts.list">
      <h2>Moje umowy</h2>
      <div className="table-wrap">
        <table className="table fin-table">
          <thead>
            <tr>
              <th scope="col">Umowa</th>
              <th scope="col">Okres</th>
              <th scope="col">Stan</th>
              <th scope="col" className="num">
                Kwota
              </th>
              <th scope="col">PDF</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((c) => (
              <tr key={c.id}>
                <td>
                  {c.number}
                  <div className="muted ctr-kind">
                    {KINDS[c.kind]} · {c.subject}
                  </div>
                </td>
                <td>
                  {plDay(c.dateFrom)} – {plDay(c.dateTo)}
                </td>
                <td>{STATES[c.state]}</td>
                <td className="num">{c.amountGrosze === undefined ? '—' : formatPln(c.amountGrosze)}</td>
                <td>
                  {c.signedFileId ? (
                    <a href={fileUrl(c.signedFileId)} target="_blank" rel="noreferrer">
                      Podpisana (skan)
                    </a>
                  ) : c.pdfFileId ? (
                    <a href={fileUrl(c.pdfFileId)} target="_blank" rel="noreferrer">
                      Pobierz PDF
                    </a>
                  ) : (
                    '—'
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
